export default "__VITE_ASSET__DZPyX2k5__"